export const Section = ({
  title,
  additionalElements,
  className,
}: {
  title: string
  additionalElements?: React.ReactNode
  className?: string
}) => {
  return (
    <div className={`border-b-2 border-shade-blue w-full italic flex justify-between items-center ${className}`}>
      <p>- {title}</p>
      {additionalElements}
    </div>
  )
}
